/**
 * Какая публикация варианта открывается кнопкой: не отменённая, черновик важнее, иначе последняя
 * утверждённая.
 *
 * Статус здесь — статус ПУБЛИКАЦИИ, а он с №285 производное от сетей: утверждена часть сетей —
 * публикация по-прежнему `draft` (работа не закончена), значит частично утверждённая выбирается как
 * черновик и открывается на доработку, а не как утверждённая.
 */
export function entryPlan<T extends { id: number; status: string }>(plans: readonly T[]): T | null {
  const live = plans.filter((p) => p.status !== "cancelled");
  const draft = live.filter((p) => p.status === "draft");
  const pool = draft.length > 0 ? draft : live.filter((p) => p.status === "approved");
  const list = pool.length > 0 ? pool : live;
  return list.reduce<T | null>((best, p) => (best === null || p.id > best.id ? p : best), null);
}
